const calcGroupIndex = (index, size) => {
    const i = Math.floor(index / size);
    if (Number.isNaN(i)) return 0;
    if (i === Infinity) return 0;
    return i;
};

const nativeAperture = (size, collection) =>
    collection.reduce((acc, item, index) => {
        const groupIndex = calcGroupIndex(index, size);
        // side-effect, but it stays inside this function
        acc[groupIndex] = [...(acc[groupIndex] || []), item];
        return acc;
    }, []);

export const aperture = size => collection => {
    if (Array.isArray(collection)) {
        return nativeAperture(size, collection);
    }
    throw Error('Unsupported collection type. Supported type is native Array.');
};

export const _testOnly = { calcGroupIndex };
